import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

import { TagValues } from "@/model/data/Tag";
import { IFilterInstallations } from "../supportObjects/IFilterInstallations";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";
import { FetchInstallationsLogAnalysisScheduleStatusResData } from "./FetchInstallationsLogAnalysisScheduleStatusResData";
const ENDPOINT = "/log_analysis/status";

export class FetchInstallationsLogAnalysisScheduleStatusCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: FetchInstallationsLogAnalysisScheduleStatusReqData;

    constructor(payload: FetchInstallationsLogAnalysisScheduleStatusReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<FetchInstallationsLogAnalysisScheduleStatusResData> {
        let res = await this.executeCommand(this.payload);
        return new FetchInstallationsLogAnalysisScheduleStatusResData(res);
    }
}

export class FetchInstallationsLogAnalysisScheduleStatusReqData implements IFilterInstallations, IPaginationFilter {
    // FilterInstallations
    installationNames: string[] = null;
    folderIds: number[] = null;
    branchNames: string[] = [];

    // PaginationFilters
    queryLimit: number = 0;
    offset: number = 0;
    orderBy: string[] = null;
    orderByDescending: boolean[] = null;

    // Other filters
    installationLastMessageDateRange: string[] = [];
    agentLastMessageDateRange: string[] = [];
    machineModels: string[] = null;
    tagValues: TagValues = null;
}
